<div class="full-screen-modal">
  <div class="flex-row flex-justify-center">
    <div class="flex-col-5 flex-col-sm-12 right">
      <span (click)="close()" class="icon-i-close"></span>
    </div>
  </div>
  <div class="flex-row flex-justify-center">
    <div class="flex-col-5 flex-col-sm-12">
      <h1>{{ 'protected_box.title' | translate }}</h1>
      <div class="white-box" *ngFor="let i of [1, 2, 3]">
        <p class="num">{{ i }}.</p>
        <p [innerHtml]="'protected_box.p_' + i | translate"></p>
      </div>
      <div id="off-box">
        <p (click)="downloadPolyregDoc()" [innerHtml]="'protected_box.p' | translate"></p>
        <p class="grey" [innerHtml]="'protected_box.price_loss' | translate"></p>
        <button (click)="close()" class="ui-button-text">
          <span class="icon-i-chevron-left"></span>
          <span>{{ 'general.back' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
